import React from 'react';
import { FileTextIcon, CreditCardIcon, ShirtIcon, PlugIcon, PhoneIcon } from 'lucide-react';
const TravelTips = () => {
  const tips = [{
    icon: <FileTextIcon size={24} className="text-red-600" data-id="element-270" />,
    title: 'Travel Documents',
    description: 'Ensure your passport is valid for at least six months beyond your travel dates and check visa requirements for your destination.'
  }, {
    icon: <CreditCardIcon size={24} className="text-red-600" data-id="element-271" />,
    title: 'Money Matters',
    description: 'Notify your bank of your travel plans to avoid card blocks, and carry a mix of payment methods including some local currency.'
  }, {
    icon: <ShirtIcon size={24} className="text-red-600" data-id="element-272" />,
    title: 'Packing Smart',
    description: "Research the weather at your destination and pack accordingly. Don't forget essentials like medications and travel adapters."
  }, {
    icon: <div size={24} className="text-red-600" data-id="element-273" />,
    title: 'Language Basics',
    description: 'Learn a few basic phrases in the local language of your destination - locals appreciate the effort even if it\'s just "hello" and "thank you".'
  }, {
    icon: <PlugIcon size={24} className="text-red-600" data-id="element-274" />,
    title: 'Power Up',
    description: 'Research the electrical outlets at your destination and pack the appropriate adapters for your devices.'
  }, {
    icon: <PhoneIcon size={24} className="text-red-600" data-id="element-275" />,
    title: 'Stay Connected',
    description: 'Check with your mobile provider about international plans or consider purchasing a local SIM card at your destination.'
  }];
  return <section className="py-16 bg-gray-50" data-id="element-276">
      <div className="container mx-auto px-4" data-id="element-277">
        <div className="text-center mb-12" data-id="element-278">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-279">
            Travel Tips & Advice
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-280">
            Make the most of your journey with these helpful tips from our
            travel experts. Being prepared will help ensure a smooth and
            enjoyable travel experience.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-281">
          {tips.map((tip, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md" data-id="element-282">
              <div className="flex items-start" data-id="element-283">
                <div className="mr-4 mt-1" data-id="element-284">{tip.icon}</div>
                <div data-id="element-285">
                  <h3 className="text-lg font-semibold mb-2 text-gray-900" data-id="element-286">
                    {tip.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-287">{tip.description}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default TravelTips;